import { Producto } from './producto.model';
import { OperationalParametric } from '../cliente/operationalParametric.model';


export class Imagen {

  static path = 'subir_imagen';
  file: File;
  path: string;
  id: number;
  name: string;
  archivoId: number;
  url: string;
  color: OperationalParametric;
  colores: OperationalParametric[];
  tipoImagen: OperationalParametric;
  personalizable: string ;
  esPersonalizable:boolean;

  constructor(file: File) {
    this.file = file;
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/imagen.model.ts